module.exports = __webpack_public_path__ + "static/img/img5d.57226e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img5d.png
// module id = iPhx
// module chunks = 1